import { loadTasks, loadWeeklyProgress } from "../../Services/IndicatorsPPCService"

export const RESOURCES_CNC_LOAD_TIMEOUT_MS = 15000

interface LoadTasksResult {
  data?: any
  error?: string
}

const loadTasksWithTimeout = async (project_id: string, week: string): Promise<LoadTasksResult> => {

  let timeoutId: ReturnType<typeof setTimeout> | undefined

  try {

    return await Promise.race<LoadTasksResult>([
      loadTasks(project_id, week),
      new Promise<LoadTasksResult>((resolve) => {
        timeoutId = setTimeout(() => resolve({ error: 'request_timeout' }), RESOURCES_CNC_LOAD_TIMEOUT_MS)
      }),
    ])
  } finally {

    if (timeoutId) clearTimeout(timeoutId)
  }
}

export const loadIndicatorsPPCWeeklyProgressAction = (project_id: string) => {

  return async (dispatch: any) => {

    dispatch({
      type: 'INDICATORS_PPC_LOADING'
    })

    const { error, data } = await loadWeeklyProgress(project_id)

    if (error) {

      dispatch({
        type: 'INDICATORS_PPC_ERROR',
        error
      })
      return false
    }

    const { data: { weeks } } = data

    dispatch({
      type: 'INDICATORS_PPC_SUCCESS',
      payload: weeks
    })

    return true
  }
}

export const loadIndicatorsPPCTasksAction = (project_id: string, week: string) => {

  return async (dispatch: any) => {

    dispatch({
      type: 'INDICATORS_PPC_TASKS_LOADING'
    })
    dispatch({
      type: 'RESOURCES_CNC_NOT_COMPLETED_LOADING',
      payload: { week }
    })

    const { error, data } = await loadTasksWithTimeout(project_id, week)

    const tasks = data?.data

    if (error || !Array.isArray(tasks?.completed) || !Array.isArray(tasks?.notCompleted)) {

      const loadError = error || 'invalid_response'

      dispatch({
        type: 'INDICATORS_PPC_TASKS_ERROR',
        error: loadError
      })
      dispatch({
        type: 'RESOURCES_CNC_NOT_COMPLETED_ERROR',
        error: loadError
      })
      return false
    }

    const { completed, notCompleted } = tasks

    dispatch({
      type: 'INDICATORS_PPC_TASKS_SUCCESS',
      payload: {
        completed,
        notCompleted
      }
    })
    dispatch({
      type: 'RESOURCES_CNC_NOT_COMPLETED_SUCCESS',
      payload: {
        notCompleted,
        week,
      }
    })

    return true
  }
}

export const cleanIndicatorsPPCAction = () => {

  return {
    type: 'INDICATORS_PPC_CLEANUP'
  }
}
